/* eslint-disable prettier/prettier */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import Mention from '@tiptap/extension-mention';
import suggestion from '../mentions/Suggestions';
import seqNumbersSuggestion from '../mentions/SeqNumberSuggestions';
import createAmountSuggestion from '../mentions/AmountSuggestions';
import TemplatePlaceholder from './components/SettingsPlaceholder';
import EventPlaceholder from './components/EventPlaceholder';
import AmountPlaceholder from './components/AmountPlaceholder';
import EventAmountPlaceholder from './components/EventAmountPlaceholder';

export const SettingsPlaceholderExtension = Mention.configure({
  HTMLAttributes: {
    class: 'mention',
  },
  renderHTML({ node }) {
    return ['span', mergeAttributes(node.attrs)];
  },
  suggestion,
}).extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: 'mention',
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(TemplatePlaceholder);
  },
});

export const SeqNumberPlaceholderExtension = Mention.configure({
  HTMLAttributes: {
    class: 'mention',
  },
  renderHTML({ node }) {
    return ['span', mergeAttributes(node.attrs)];
  },
  suggestion: seqNumbersSuggestion,
}).extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: 'mention',
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(TemplatePlaceholder);
  },
});

export const EventPlaceholderExtension = SettingsPlaceholderExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(EventPlaceholder);
  },
});

export const createAmountPlaceholderExtension = (includeCustomFields: boolean) =>
  Mention.configure({
    HTMLAttributes: {
      class: 'mention',
    },
    renderHTML({ node }) {
      return ['span', mergeAttributes(node.attrs)];
    },
    suggestion: createAmountSuggestion(includeCustomFields),
  }).extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        class: {
          default: 'mention',
        },
      };
    },
    addKeyboardShortcuts() {
      return {
        ...this.parent?.(),
        Enter: () => {
          const pluginState = this.options.suggestion.pluginKey?.getState(this.editor.state);
          if (pluginState?.active) {
            return false;
          }
          this.editor.commands.blur();
          return true;
        },
      };
    },
    addNodeView() {
      return ReactNodeViewRenderer(AmountPlaceholder);
    },
  });

export const createEventAmountPlaceholderExtension = (includeCustomFields: boolean) =>
  createAmountPlaceholderExtension(includeCustomFields).extend({
    addNodeView() {
      return ReactNodeViewRenderer(EventAmountPlaceholder);
    },
  });
